import React, { Component, useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { parseCoordinate } from "./coordinate";

const DEFAULT_CENTER = { lat: -6.2, lng: 106.816666 }; // default Jakarta

// Custom red icon untuk marker
const redIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

// Component untuk ubah view (hanya saat center berubah, bukan tiap render)
function ChangeView({ center }) {
  const map = useMap();
  useEffect(() => {
    map.setView([center.lat, center.lng], 15);
  }, [map, center.lat, center.lng]);
  return null;
}

// Component untuk handle klik map
function ClickHandler({ onMapClick }) {
  useMapEvents({
    click(e) {
      onMapClick(e.latlng);
    },
  });
  return null;
}

export default class MapsComponents extends Component {
  constructor(props) {
    super(props);

    // ponytail: pakai koordinat tersimpan kalau ada, GPS hanya fallback.
    // Kalau butuh reverse-geocode label alamat, tambah di handleSelectLocation.
    const saved = parseCoordinate(props.coordinate);
    const coordinate = saved || DEFAULT_CENTER;

    this.state = {
      center: coordinate,
      markers: [
        {
          position: coordinate,
          display_name: saved ? "Lokasi Tersimpan" : "Default",
        },
      ],
      query: "",
      results: [],
    };
  }

  componentDidMount() {
    // Jangan ambil GPS & jangan timpa koordinat kalau data sudah punya lokasi
    if (parseCoordinate(this.props.coordinate)) return;

    // Dapatkan current GPS position
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        // Data tersimpan bisa selesai load sebelum GPS resolve; jangan ditimpa
        if (parseCoordinate(this.props.coordinate)) return;

        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        this.setState({
          center: { lat, lng },
          markers: [{ position: { lat, lng }, display_name: "Lokasi Anda" }],
        });
      });
    }
  }

  componentDidUpdate(prevProps) {
    // Prop coordinate berubah (data async selesai load / parent reset)
    if (prevProps.coordinate !== this.props.coordinate) {
      const saved = parseCoordinate(this.props.coordinate);
      if (saved) {
        this.setState({
          center: saved,
          markers: [{ position: saved, display_name: "Lokasi Tersimpan" }],
        });
      }
    }
  }

  // Klik map → set koordinat
  handleMapClick = (latlng) => {
    const { lat, lng } = latlng;

    this.setState({
      center: { lat, lng },
      markers: [{ position: { lat, lng }, display_name: "Custom Position" }],
    });

    localStorage.setItem("coordinate", JSON.stringify({ lat, lng }));
    localStorage.setItem("address", "Custom Position");

    if (this.props.onChangeLocation) {
      this.props.onChangeLocation("Custom Position", { lat, lng });
    }
  };

  // Input search → request Nominatim
  handleSearch = (e) => {
    const query = e.target.value;
    this.setState({ query });

    if (this.searchTimeout) clearTimeout(this.searchTimeout);

    this.searchTimeout = setTimeout(async () => {
      if (query.length > 2) {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?q=${query}&format=json&addressdetails=1&accept-language=id`
        );
        const data = await response.json();
        this.setState({ results: data });
      } else {
        this.setState({ results: [] });
      }
    }, 300); // delay 300ms
  };

  // Pilih lokasi dari hasil pencarian
  handleSelectLocation = (place) => {
    const lat = parseFloat(place.lat);
    const lng = parseFloat(place.lon);

    this.setState({
      center: { lat, lng },
      markers: [{ position: { lat, lng }, display_name: place.display_name }],
      query: place.display_name,
      results: [],
    });

    localStorage.setItem("coordinate", JSON.stringify({ lat, lng }));
    localStorage.setItem("address", place.display_name);

    if (this.props.onChangeLocation) {
      this.props.onChangeLocation(place.display_name, { lat, lng });
    }
  };

  render() {
    return (
      <div style={{ position: "relative" }}>
        <MapContainer
          center={this.state.center}
          zoom={15}
          style={{
            height: "50vh",
            width: "100%",
            borderRadius: "8px",
            zIndex: 0,
          }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />

          <ChangeView center={this.state.center} />

          {/* Klik map */}
          <ClickHandler onMapClick={this.handleMapClick} />

          {/* Marker */}
          {this.state.markers.map((marker, idx) => (
            <Marker key={idx} position={marker.position} icon={redIcon}>
              <Popup>{marker.display_name}</Popup>
            </Marker>
          ))}
        </MapContainer>

        {/* Search box float */}
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "80%",
            maxWidth: "500px",
            zIndex: 0,
          }}
        >
          <div style={{ position: "relative", width: "100%" }}>
            <input
              type="text"
              placeholder="Cari lokasi..."
              value={this.state.query}
              onChange={this.handleSearch}
              style={{
                width: "100%",
                padding: "10px 35px 10px 10px", // kasih space kanan biar nggak ketimpa tombol
                borderRadius: "8px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                fontSize: "14px",
              }}
            />

            {this.state.query && (
              <button
                onClick={() => this.setState({ query: "" })}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  fontSize: "16px",
                  color: "#888",
                }}
              >
                ✖
              </button>
            )}
          </div>

          {/* Sugesti hasil search */}
          {this.state.results.length > 0 && (
            <ul
              style={{
                listStyle: "none",
                margin: 0,
                padding: 0,
                maxHeight: "200px",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: "0 0 8px 8px",
                background: "#fff",
                position: "absolute",
                top: "40px",
                left: 0,
                right: 0,
                zIndex: 1,
              }}
            >
              {this.state.results.map((place, idx) => (
                <li
                  key={idx}
                  onClick={() => this.handleSelectLocation(place)}
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  {place.display_name}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    );
  }
}
